import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px 0;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
    border: 2px solid #f1f1f1;

    &:hover {
      background: #555;
    }
  }
`;

export const FileTitle = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.customPalette?.gray?.[950]};
  margin: 8px 0 0 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 130px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  flex-shrink: 0;
`;

export const CheckboxArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: start;
  align-items: end;
  padding: 2px;
  z-index: 2;
  position: absolute;
  top: 1px;
  left: 2px;
`;

export const CanvasContainer = styled.canvas`
  background-color: 'rgba(0, 0, 0, 0)';
  z-index: 1150;
  border: 1px solid red;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
`;

export const Sidebar = styled.div`
  position: fixed;
  top: 10%;
  left: 16px;
  display: flex;
  transform: translateY(-50%);
  flex-direction: column;
  padding: 8px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.customPalette?.gray?.[950]};
  z-index: 1151;
`;

export const SidebarButton = styled.button`
  background-color: ${({ theme }) => theme.customPalette?.gray?.[950]};
  color: ${({ theme }) => theme.customPalette?.white};
  border: none;
  cursor: pointer;
  padding: 5px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    background-color: ${({ theme }) => theme.customPalette?.gray?.[600]};
  }

  transition: background-color 0.2s;
`;

export const DeleteIconButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px;
  border: none;
  border-radius: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;
